export default __webpack_public_path__ + "static/media/three-dots-vertical.374cb61c.svg";